<template>
  <div>
    <div class="comm_popup_wrap_large">
      <div class="comm_title_wrap">
        <h4>{{ $t('MSG_TXT_DATA_EXTC_TYPE_BSC_INFO') }}</h4>
      </div>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-4">
            <sui-module-submodule-select
              ref="smComboFrame0"
              class="dp_flex"
              :pageId="this.$options.name"
              :selectedMd="frame0.selectData.COD_MDLE"
              :selectedSmd="frame0.selectData.COD_SMDLE"
            />
          </div>
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_DATA_EXTC_TYPE_NM')"
              :required="true"
              :vertical="false"
            />
          </div>
          <div class="col-xs-4">
            <cmp-mlng-editor
              ref="mlngEditor"
              :pageId="pageId"
              :vertical="false"
              :editable="true"
              :multiLanguageId="frame0.data.dataExtractionTypeMultiLanguageId"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_EXPL')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <textarea
              v-model="frame0.data.dataExtractionContent"
              maxlength="1000"
            />
          </div>
        </div>
      </div>
      <div class="comm_title_wrap">
        <h4>{{ $t('MSG_TXT_DATA_EXTC_TYPE_DTL_INFO') }}</h4>
      </div>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_MASS_EXTC_YN')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <sui-radio
              v-model="frame0.data.dataExtractionBigQuantityYn"
              value="Y"
            >
              Yes
            </sui-radio>
            <sui-radio
              v-model="frame0.data.dataExtractionBigQuantityYn"
              value="N"
            >
              No
            </sui-radio>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_DATA_EXTC_BAT')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <sui-text-field
              v-model="frame0.data.batchJobId"
              maxlength="100"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_EXTC_STNRD')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <sui-text-field
              v-model="frame0.data.dataExtractionStandardValue"
              maxlength="122"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_LIMIT_DT')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <sui-text-field
              v-model="frame0.data.dataExtractionRestrictionPeriod"
              mask="number"
              maxlength="4"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_PIC_TYPE')"
              :vertical="false"
              :required="true"
            />
          </div>
          <div class="col-xs-10">
            <sui-text-field
              v-model="frame0.data.picTypeName"
              :readonly="true"
              :disabled="true"
            />
            <sui-button
              type="button"
              class="comm_btn_InputScr"
              @click="onPicClick"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_USE_YN')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <sui-radio
              v-model="frame0.data.dataExtractionTypeUseYn"
              value="Y"
            >
              Yes
            </sui-radio>
            <sui-radio
              v-model="frame0.data.dataExtractionTypeUseYn"
              value="N"
            >
              No
            </sui-radio>
          </div>
        </div>
      </div>
    </div>
    <div class="comm_btn_wrap mrR30">
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="onCancelClick"
      >
        {{ $t('MSG_BTN_CANCEL') }}
      </sui-button>
      <sui-button
        v-permission:update="'PGE_CMS_00010'"
        type="button"
        class="comm_btn_solid"
        @click="onSaveClick"
      >
        {{ $t('MSG_BTN_SAVE') }}
      </sui-button>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMS_00010_P01', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    closePagePopup: {
      type: Function,
      default() { return null; },
    },
    pageId: {
      type: String,
      default: 'PGE_CMS_00010',
    },
    selectedGridRowData: {
      type: Object,
      default() { return {}; },
    },
  },
  data() {
    return {
      codes: CommonConstants.selectOptions(),
      frame0: {
        selectData: {
          COD_MDLE: {
            label: '',
            key: '',
          },
          COD_SMDLE: {
            label: '',
            key: '',
          },
        },
        data: {},

      },
      // 신규인지 수정인지 여부
      isCreate: true,
      dataExtractionTypeName: '',
    };
  },
  computed: {
    // 계산된 속성, date pickproperty로 사용가능
  },
  watch: {
    // data 변경시 특정 함수를 호출 해야 하는 경우(async 등)
  },
  mounted() {
    // 화면 초기화
    this.$refs.smComboFrame0.reset();
    this.frame0.data = {
      dataExtractionBigQuantityYn: 'N',
      dataExtractionTypeUseYn: 'Y',
      picTypeId: '',
      picTypeName: '',
      dataExtractionTypeMultiLanguageId: '',
    };

    if (this.$props.selectedGridRowData && this.$props.selectedGridRowData.dataExtractionTypeUid) {
      this.isCreate = false;
      this.$nextTick(() => {
        const selectedGridRowData = utils.cloneDeep(this.$props.selectedGridRowData);
        const { dataExtractionRestrictionPeriod } = selectedGridRowData;
        selectedGridRowData.dataExtractionRestrictionPeriod = dataExtractionRestrictionPeriod.toString();
        this.frame0.data = selectedGridRowData;
        // if(this.frame0.data.dataExtractionTypeName[0].key) {
        //   this.dataExtractionTypeName = this.frame0.data.dataExtractionTypeName[0].key;
        // }
        // else {
        //   this.dataExtractionTypeName = this.frame0.data.dataExtractionTypeName;
        // }
        this.selectDataFormInput();
      });
    } else {
      this.isCreate = true;
    }
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    selectDataFormInput() {
      // set code combo
      this.frame0.selectData.COD_MDLE = { key: this.frame0.data.moduleCode };
      this.frame0.selectData.COD_SMDLE = { key: this.frame0.data.subModuleCode };
    },
    onSaveClick() {
      if (utils.isEmpty(utils.trim(this.$refs.mlngEditor.$refs.localTxtFld.value))) {
        // local 언어를 입력해주세요
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_LOCAL_LNG')),
          null,
          () => {
            this.$refs.mlngEditor.setFocusLocalTxtFld();
          });

        return false;
      }
      if (utils.isEmpty(utils.trim(this.$refs.mlngEditor.$refs.globalTxtFld.value))) {
        // global 언어를 입력해주세요
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_GLOBAL_LNG')),
          null,
          () => {
            this.$refs.mlngEditor.setFocusGlobalTxtFld();
          });

        return false;
      }
      // if (!this.frame0.data.dataExtractionTypeName) {
      //   const msg = utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_DATA_EXTC_TYPE_NM'));
      //   utils.messageBox('warning', msg);
      //   return false;
      // }
      if (!this.frame0.data.picTypeId) {
        const msg = utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_PIC_TYPE'));
        utils.messageBox('warning', msg);
        return false;
      }
      const multiLanguageList = this.$refs.mlngEditor.getMlngEditingInfoFillEmptyWithGlobal();
      const requestData = utils.cloneDeep(this.frame0.data);
      requestData.moduleCode = this.frame0.selectData.COD_MDLE.key;
      requestData.subModuleCode = this.frame0.selectData.COD_SMDLE.key;
      requestData.dataExtractionTypeName = this.frame0.data.dataExtractionTypeName;
      if (!requestData.dataExtractionBigQuantityYn) {
        requestData.dataExtractionBigQuantityYn = 'N';
      }
      requestData.originalFinalModificationDTM = this.frame0.data.finalModificationDTM;
      requestData.multiLanguageList = multiLanguageList;
      requestData.dataExtractionTypeName = this.$refs.mlngEditor.$refs.localTxtFld.value;


      const dataServiceId = this.isCreate ? 'DTS_CMS_00031' : 'DTS_CMS_00032';
      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
        http.request(this.pageId, dataServiceId, {
          data: requestData,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'));
          this.$emit('close');
        }).catch(error => {
          console.log(error);
        });
      });

      return null;
    },
    onCancelClick() {
      this.$emit('close');
    },
    /*
     * 담당자 유형 선택 팝업
     */
    onPicClick() {
      utils.openLayerPopup('PGE_CMZ_00006', this.onPicPopupCallback, {
        pageInitialData: {},
        size: 'xlg',
      });
    },
    onPicPopupCallback(objPicType) {
      //      utils.alert(JSON.stringify(objPicType), this.$t('MSG_BTN_CFRM'), () => {});
      if (utils.isEmpty(objPicType) === false) {
        this.frame0.data.picTypeId = objPicType[0].picTypeId;
        this.frame0.data.picTypeName = objPicType[0].picTypeName;
      }
    },
  },
};
</script>
<style scoped>
</style>
